// Mana frontend default configuration.
// Copy config/local.js.example to config/local.js for local overrides (gitignored).
//
// api.baseURL is sent to the browser (axios). It must be a same-origin path
// like '/api', otherwise visitors would request their own machine.
// api.proxyTarget is used only by Vite on the server to forward /api
// to the backend. It never needs to be a public hostname.

export default {
  api: {
    baseURL: '/api',
    proxyTarget: 'http://127.0.0.1:6001',
    timeout: 10000,
    apiKey: '',
  },
  server: {
    port: 3000,
    host: '0.0.0.0',
    open: true,
    allowedHosts: [
      'localhost',
      '127.0.0.1',
      '.lookwing.com',
      '.onefull.com',
    ],
    hmrClientPort: 443,
  },
}
